const BASE_URL = import.meta.env.VITE_API_BASE_URL || '/polysports-api';

const getOptionalAuthHeaders = () => {
  const token = localStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const buildUrl = (path) => {
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  return `${BASE_URL}${path}`;
};

const parseResponse = async (response) => {
  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }
  return { ok: response.ok, status: response.status, data };
};

const fetchWithOptionalAuth = async (path, options = {}) => {
  const url = buildUrl(path);
  const response = await fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      ...getOptionalAuthHeaders(),
    },
  });

  if (response.status === 401 || response.status === 403) {
    const retry = await fetch(url, options);
    return parseResponse(retry);
  }

  return parseResponse(response);
};

export const bonusPoolApi = {
  getRounds: () => fetchWithOptionalAuth('/bonus-pool/rounds'),
  getMyTickets: (roundId) => fetchWithOptionalAuth(`/bonus-pool/my-tickets/${roundId}`),
  getRoundDetail: (roundId) => fetchWithOptionalAuth(`/bonus-pool/round/${roundId}`),
  claimPrize: (prizeId) =>
    fetchWithOptionalAuth(`/bonus-pool/claim/${prizeId}`, { method: 'POST' }),
  getInviteSummary: () => fetchWithOptionalAuth('/bonus-pool/invite/summary'),
  applyInviteCode: (inviteCode) =>
    fetchWithOptionalAuth('/bonus-pool/invite/apply', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ invite_code: inviteCode }),
    }),
  exportPrivateKey: () =>
    fetchWithOptionalAuth('/bonus-pool/wallet/export-private-key', { method: 'POST' }),
};
